import { Component, Input, Inject } from '@angular/core';
import {DeviceEntity} from "../../entities/device.entity";
import {GatewayEntity} from "../../entities/gateway.entity";

@Component({
  selector: 'embed-gateway',
  template: `
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Gateway</div>
          <div class="card-body"><pre>{{entity?.toJson(options) | json}}</pre></div>
        </div>
      </div>
    </div>
    `
})
export class EmbedGatewayComponent {
  @Input() entity: GatewayEntity = null;
  @Input() options: any = null;
  @Input() layout: string = null;
  constructor() {
  }

}
